import type { HTMLComponent } from "@commercekit/react";
import WvLink from "~/components/atoms/WvLink";
import type { WovarCategory } from "@commercekit/api";
import { useLocalePath, useLocale } from "@commercekit/remix/index";
import { useGlobalCtx } from "~/store/globalState";
import { optimizeImageUrl } from "~/lib/imageUtils";
import { CATEGORY_IMAGE_PLACEHOLDER_URL } from "~/components/icons/CategoryImagePlaceholder";

const WvCategoriesInHexagon: HTMLComponent<{
  categoryData: WovarCategory;
}> = ({ categoryData }) => {
  const localePath = useLocalePath();
  const {
    dispatch: { setCurrentPage },
  } = useGlobalCtx();
  const { locale } = useLocale();
  return (
    <div className="text-center mb-3">
      <h1 className="heading xl underlined pb-2 pb-lg-3 mb-4 mt-3">
        {categoryData?.name}
      </h1>

      <div className="categories-in-hexagon mb-3 mb-lg-5">
        {categoryData?.children?.map((category) => (
          <WvLink
            key={category?.id}
            to={localePath(`/${category?.slug}`)}
            className="component-categoryblock"
            onClick={() => setCurrentPage("categoryPage")}
          >
            <div
              className="hexagon-clip d-flex align-items-center justify-content-center mx-auto"
            >
              <img
                src={category?.images[0]?.urlOriginal
                  ? optimizeImageUrl(category.images[0].urlOriginal, { width: 200, height: 200 })
                  : CATEGORY_IMAGE_PLACEHOLDER_URL
                }
                alt={category?.images[0]?.altText || ""}
              />
            </div>
            <div className="category-name">
              <span lang={locale}>
                {category?.name}
              </span>
            </div>
          </WvLink>
        ))}
      </div>
    </div>
  );
};
export default WvCategoriesInHexagon;
